// src/config.js - Configuration file for easy editing
export const SITE_CONFIG = {
  // Brand Information
  brandName: "Savvy Shopper",
  domain: "savvy.cheap",
  logoPath: "/SavvyShopper_logo.png",

  // Affiliate Settings
  affiliateTag: "savvy0024-20",

  // API Configuration
  apiUrl: "https://odealia.pythonanywhere.com",

  // Display Settings
  display: {
    navbar: {
      discordButton: false  // Toggle Discord button in navbar
    },
    footer: {
      xIcon: false,        // Toggle X/Twitter icon in footer
      discordIcon: false   // Toggle Discord icon in footer
    }
  },

  // Social Media Links
  social: {
    discord: "https://discord.gg/clearance",
    twitter: "https://x.com/SavvyShopper"
  },

  // Contact Information
  contact: {
    email: "support@savvy.cheap",
    privacyEmail: "privacy@savvy.cheap"
  },

  // Theme Configuration
  theme: {
    light: {
      primary: {
        bg: "from-pink-50 via-purple-50 to-rose-50",
        text: "text-gray-900",
        accent: "from-pink-600 via-purple-600 to-rose-600",
        accentHover: "from-pink-700 via-purple-700 to-rose-700",
        card: "bg-white/95 backdrop-blur-lg border-pink-200/50",
        cardHover: "bg-white",
        button: "from-pink-500 to-purple-500",
        buttonHover: "from-pink-600 to-purple-600",
        discountBadge: "from-rose-500 to-pink-600",
        navbar: "bg-white/95 backdrop-blur-lg border-pink-200/50",
        footer: "bg-white/95 backdrop-blur-lg border-pink-200/50",
        textSecondary: "text-gray-800",
        textMuted: "text-gray-600"
      },
      gradients: {
        hero: "from-pink-50 via-purple-50 to-rose-50",
        card: "from-white/95 to-pink-50/95",
        button: "from-pink-500 to-purple-500",
        accent: "from-pink-500 to-rose-500"
      }
    },
    dark: {
      primary: {
        bg: "from-gray-900 via-purple-900/30 to-pink-900/30",
        text: "text-gray-100",
        accent: "from-pink-400 via-purple-400 to-rose-400",
        accentHover: "from-pink-300 via-purple-300 to-rose-300",
        card: "bg-gray-800/95 backdrop-blur-lg border-pink-700/30",
        cardHover: "bg-gray-800",
        button: "from-pink-500 to-purple-500",
        buttonHover: "from-pink-400 to-purple-400",
        discountBadge: "from-rose-400 to-pink-500",
        navbar: "bg-gray-900/95 backdrop-blur-lg border-pink-700/30",
        footer: "bg-gray-900/95 backdrop-blur-lg border-pink-700/30",
        textSecondary: "text-gray-200",
        textMuted: "text-gray-400"
      },
      gradients: {
        hero: "from-gray-900 via-purple-900/30 to-pink-900/30",
        card: "from-gray-800/95 to-gray-900/95",
        button: "from-pink-500 to-purple-500",
        accent: "from-pink-400 to-rose-400"
      }
    }
  },

  // Page Content
  content: {
    home: {
      heroTitle: "Shop Smart, Save More",
      heroSubtitle: "Your trusted companion for discovering the best deals and savings. We curate premium offers and share savvy shopping tips to help you maximize your budget while enjoying the things you love.",
      heroButton: "Start Saving Today",

      whoThisIsFor: {
        title: "Who We Help Save",
        items: [
          {
            icon: "💰",
            text: "Budget-Conscious Shoppers: Women who want to stretch their dollars further and find amazing deals without compromising on quality or style."
          },
          {
            icon: "✨",
            text: "Smart Spenders: Those who love shopping but also love saving, looking for the perfect balance between treating themselves and being financially savvy."
          },
          {
            icon: "🎯",
            text: "Deal Hunters: Savvy shoppers who enjoy the thrill of finding incredible bargains and sharing their finds with friends and family."
          }
        ]
      }
    },

    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know about Savvy Shopper.",
      items: [
        {
          question: "What is Savvy Shopper?",
          answer: "Savvy Shopper is your trusted shopping companion that helps you discover the best deals and savings opportunities. We curate premium offers and share expert tips to help you shop smarter and save more."
        },
        {
          question: "How do I get started?",
          answer: "Simply browse our deals section to start discovering savings! You can filter by category, retailer, or discount percentage to find exactly what you're looking for."
        },
        {
          question: "What types of deals do you feature?",
          answer: "We feature deals across all major categories including fashion, beauty, home, electronics, and more. Our team constantly monitors prices to bring you the best savings opportunities from top retailers."
        },
        {
          question: "Is it free to use?",
          answer: "Yes! Savvy Shopper is completely free to use. We earn small commissions from retailers when you make purchases through our links, which helps us keep the service free for you."
        },
        {
          question: "How often are deals updated?",
          answer: "We update our deals continuously throughout the day, with thousands of price changes monitored daily to ensure you never miss a great savings opportunity."
        }
      ]
    }
  }
};
